<template>
  <div class="slider">
    <img :src="images[current]" alt="Karate" class="slide-img" />
    <div class="controls">
      <button @click="prev">‹</button>
      <button @click="next">›</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSlider',
  data() {
    return {
      images: [
        'https://scontent-lis1-1.xx.fbcdn.net/v/t39.30808-6/480694708_1172195168242433_5785830161835285130_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=2a1932&_nc_ohc=oheaR2Ohs2kQ7kNvwFHKDAG&_nc_oc=AdmJydolHs4kWixz4EwegzbwqM1tc4Lj7lQEnFlXgrpj4ifrpT5O_JblYvcu8bh2Kco&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=K7yz-fVPRM03lUxzPlUxTQ&_nc_ss=8&oh=00_AfxmWCfyJau7LFGfkDIN_Zyqg6meka0qyIiCVBJMQtSEGA&oe=69ACB8A9',
        'https://scontent-lis1-1.xx.fbcdn.net/v/t39.30808-6/497755011_4085566661761986_7769672344378163905_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=2a1932&_nc_ohc=KE12aKiIqxYQ7kNvwExImza&_nc_oc=Adm5rb_C26JTRuOlPzPJdh698nwIRNgAhLNqrtIgVHM7y2ZqozBZyRB_pS7ZbKmbDzY&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=RTTaOMbhwmvhHao6R5yY6g&_nc_ss=8&oh=00_AfzfLhsTuWi6_6U4uLxJrGbKc4ZQgCNUP2mQv1j2M5RPkA&oe=69ACA093'
      ],
      current: 0,
    };
  },
  methods: {
    next() {
      this.current = (this.current + 1) % this.images.length;
    },
    prev() {
      this.current = (this.current - 1 + this.images.length) % this.images.length;
    },
  },
};
</script>

<style scoped>
.slider {
  width: 100%;
  max-height: 600px;
  position: relative;
  overflow: hidden;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide-img {
  width: 100%;
  max-height: 600px;
  object-fit: contain;
}
.controls {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
}
.controls button {
  background: rgba(0,0,0,0.5);
  color: #fff;
  border: none;
  font-size: 2rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .slider {
    max-height: 300px;
  }
  .slide-img {
    max-height: 300px;
  }
}

@media (max-width: 480px) {
  .slider {
    max-height: 200px;
  }
  .slide-img {
    max-height: 200px;
  }
  .controls button {
    width: 32px;
    height: 32px;
    font-size: 1.5rem;
  }
}
</style>

